import styled, { keyframes, css } from 'styled-components';
import { InputSize } from './types';

const spin = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

interface SearchContainerProps {
  fullWidth?: boolean;
  width?: string;
}

export const SearchContainer = styled.div<SearchContainerProps>`
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  ${({ fullWidth, width }) => fullWidth
    ? css`width: 100%;`
    : width
      ? css`width: ${width};`
      : css`width: auto;`
  }
`;

export const Label = styled.label`
  font-size: 15px;
  font-weight: 700;
  min-width: 80px;
`;

interface InputProps {
  inputSize?: InputSize;
}

const getInputHeight = (size: InputSize = 'medium') => {
  switch (size) {
    case 'small':
      return '32px';
    case 'large':
      return '48px';
    case 'medium':
    default:
      return '40px';
  }
};

const getInputPadding = (size: InputSize = 'medium') => {
  switch (size) {
    case 'small':
      return '0 8px';
    case 'large':
      return '0 16px';
    case 'medium':
    default:
      return '0 12px';
  }
};

const getFontSize = (size: InputSize = 'medium') => {
  switch (size) {
    case 'small':
      return '12px';
    case 'large':
      return '16px';
    case 'medium':
    default:
      return '14px';
  }
};

export const SearchInput = styled.input<InputProps>`
  flex: 1;
  height: ${({ inputSize }) => getInputHeight(inputSize)};
  padding: ${({ inputSize }) => getInputPadding(inputSize)};
  border: 1px solid ${({ theme }) => theme.borderColor || '#ccc'};
  border-radius: 4px 0 0 4px;
  font-size: ${({ inputSize }) => getFontSize(inputSize)};

  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.primaryColor || '#4dc9c9'};
    box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
  }
`;

export const SearchButton = styled.button<InputProps>`
  background-color: rgb(40, 96, 144);
  height: ${({ inputSize }) => getInputHeight(inputSize)};
  width: ${({ inputSize }) => getInputHeight(inputSize)};
  border: none;
  border-radius: 0 4px 4px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: rgb(32, 77, 116);
  }

  svg {
    color: white;
    width: 16px;
    height: 16px;
  }

  &:disabled svg {
    animation: ${spin} 1s linear infinite;
  }
`;
